
const partnersComissionListReducer = (state = {
    loading:false,
    comission:[],totalRecords:0,msg:''
}, action) => {
    switch (action.type) {
        case "FETCH_PARTNER_COMISSION_LIST":
            return { ...state ,loading:true,comission:[],totalRecords:0,msg:''}
        case "RECEIVE_PARTNER_COMISSION_LIST":
            return {...state, comission:[...action.payload.data],loading:false,totalRecords:action.payload.totalRecords,msg:''}
        case "ERROR_PARTNER_COMISSION_LIST":
            return { ...state ,comission:[],loading:false,totalRecords:0,msg:action?.payload}
        default:
            return { ...state }
    }
}

export default partnersComissionListReducer;